(function() {
    'use strict';

    angular
        .module('elogbooks.user.reports')
        .controller('SPUsageTabsController', SPUsageTabsController);

    SPUsageTabsController.$inject = ['$state', '$stateParams', 'countCollectionResponse', 'modulesService', 'rootResourceResponse'];

    function SPUsageTabsController($state, $stateParams, countCollectionResponse, modulesService, rootResourceResponse) {
        var vm = this;
        vm.stateParams = $stateParams;
        vm.exportParams = {
            site: vm.stateParams.site,
            serviceProvider: vm.stateParams.serviceProvider,
            dateRange: vm.stateParams.dateRange
        };

        vm.countCollection = countCollectionResponse;
        vm.taskModuleEnabled = modulesService.isEnabled('tasks_module') || rootResourceResponse.plannedJobsExist;
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
    }
})();